<template>

    <div class="container card p-5 shadow col-md-5 m-auto">
        
        <h1>Create Questionnaire for Step {{currentCategoryStep.title}} in Category {{currentCategory.title}}</h1>
        <hr>
        
        <div v-if="response.success != null" v-bind:class="{ 'alert-success': response.success, 'alert-danger': !response.success }" class="alert" role="alert">
            {{response.message}}
        </div>

        <div id="form">
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">Title</span>
                </div>
                <input v-model="questionnaire.title" type="text"  class="form-control" placeholder="Enter Title">
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">Title Key</span>
                </div>
                <input v-model="questionnaire.titleTranslationKey" type="text" class="form-control" placeholder="Enter Title Translation Key">
                <div class="autocomplete-items">
                    <div v-if="!isKeySelected">
                        <input class="form-control" v-for="titleTranslationKey in titleTranslationKeys" :key="titleTranslationKey.id" @click="questionnaire.titleTranslationKey = titleTranslationKey.key; selectKey();" readonly :value="titleTranslationKey.key">
                    </div>
                    <input class="form-control" v-if="questionnaire.titleTranslationKey && !isKeyInTitleTranslationKeys()" @click="createKey()" readonly :value="'Generate Key ' + questionnaire.titleTranslationKey">
                    
                </div>
            </div>
            
        </div>
        <button @click="addQuestionnaire()" type="button" class="btn btn-primary mb-3">Add Questionnaire</button>
        
    </div>

</template>

<script>
export default {
    data() {
        return {
            isKeySelected: false,
            titleTranslationKeys: [],
            questionnaire: {
                title: null,
                titleTranslationKey: null,
                key: null
            },
            response: {},
            addKeyResponse: {},
            keyIndex: null,
            currentCategory: {},
            currentCategoryStep: {}
        }
    },
    methods: {
        loadCurrentCategoryStep: function() {
            let self = this;
            this.$http.get('/api/category-steps/get/' + this.$route.query.step)
            .then(response => {
                self.currentCategoryStep = response.data;
            })
            .catch(error => {
                console.log(error);
                self.$router.push("/404");
            })
        },
        loadCurrentCategory: function() {
            let self = this;
            this.$http.get('/api/categories/get/' + this.$route.query.category)
            .then(response => {
                self.currentCategory = response.data;
            })
            .catch(error => {
                console.log(error);
                self.$router.push("/404");
            })
        },
        addQuestionnaire: function(){
            if(this.keyIndex === -1){
                this.response = {"success": false, "message": "Given Title Translation Key is either not generated or not selected"}
            }
            else
            {
                let self = this;
                this.$http.post('/api/questionnaires/add-and-assign-to-category-step/' + this.$route.query.step , this.questionnaire)
                .then(response => {
                    self.response = response.data;
                    //self.updateCategoryStep();
                })
                .catch(error => {
                    console.log(error);
                })
            }
        },
        translationKeySearch: function(){
            let self = this;
            this.$http.get('/api/languages/search/' + this.questionnaire.titleTranslationKey)
            .then(response => {
                self.titleTranslationKeys = response.data;
            })
            .catch(error => {
                console.log(error);
            })
        },
        createKey: function(){
            let self = this;
            this.questionnaire.key = this.questionnaire.titleTranslationKey;
            this.$http.post('/api/languages/add-translation/', self.questionnaire)
            .then(response => {
                self.addKeyResponse = response.data;
                self.translationKeySearch();
            })
            .catch(error => {
                console.log(error);
            })
        },
        selectKey: function(){
            this.keyIndex = this.titleTranslationKeys.map(function(item) { return item.key; }).indexOf(this.questionnaire.titleTranslationKey);
            this.isKeySelected = true
        },
        isKeyInTitleTranslationKeys: function(){
            var index = this.titleTranslationKeys.map(function(item) { return item.key; }).indexOf(this.questionnaire.titleTranslationKey);
            if(index >= 0)
                return true;
            else
                return false;
        }
    },
    mounted: function() {
        this.loadCurrentCategory();
        this.loadCurrentCategoryStep();
    },
    watch: {
        response: function(val){
            if(val.success === true){
                setTimeout(() => {
                    this.$router.push(`/admin/categories/${this.$route.query.category}/steps`);
                }, 1000)
            }
            setTimeout(() => {
                this.response.success = null;
            }, 3000) 
        },
        addKeyResponse: function(val){
            if(val.success === true)
            {
                this.titleTranslationKeys.push(this.questionnaire.key);
            }
        },
        'questionnaire.titleTranslationKey' : function(val){
            var correctVal = val.toUpperCase().replace('-', '_').replace(' ','_').replace(/[^_\dA-Z]/, '');
            if(this.questionnaire.titleTranslationKey !== correctVal)
                this.questionnaire.titleTranslationKey = correctVal;
            else{
                // get index of object with key: val
                this.keyIndex = this.titleTranslationKeys.map(function(item) { return item.key; }).indexOf(val);  
                if(this.keyIndex === -1)
                    this.isKeySelected = false;

                if(this.questionnaire.titleTranslationKey)
                    this.translationKeySearch();
                else
                    this.titleTranslationKeys = [];
            }
        }
        
    }
    
}
</script>

<style lang="scss">
.autocomplete{
  position: relative;
  display: inline-block;
}
input{
  border: 1px solid transparent;
  background-color: #f1f1f1;
  padding: 10px;
  font-size: 16px;
  &[type=text]
  {
    width: 100%;
  }
}

.autocomplete-items
{
  position: absolute;
  border: 1px solid #d4d4d4;
  border-bottom: none;
  border-top: none;
  z-index: 99;
  top: 100%;
  left: 0;
  right: 0;
  input{
    padding: 10px;
    cursor: pointer;
    background-color: #fff;
    border-bottom: 1px solid #d4d4d4;
    &:hover{
      background-color: #e9e9e9;
    }
  }
}
.autocomplete-active{
  background-color: DodgerBlue !important;
  color: #ffffff;
}


div{
    span.input-group-text {
        width: 85px;
    }
}

.form-control[readonly] {
    background-color: white;
}
</style>
